module.exports = __webpack_public_path__ + "media/images/icons/headset-757eef1a30a9e35206229f238522f6c4.svg";